import { useState, useEffect, useRef } from "react";
import { Form, Spin, Card, Row, Col, Input, Checkbox, Tabs, Button, Select } from "antd";
import { PageHeader } from '@ant-design/pro-components';

import { colors } from "../../../styles/colors";
import { apiCand } from "../../../services/apiCand";
import { IPepSituacao, IPessoaFisica } from "../Componentes/InterfacePessoaFisica";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";
import PessoaFisicaEndereco from "../Componentes/PessoaFisicaEndereco";
import PessoaFisicaDocumento from "../Componentes/PessoaFisicaDocumento"
import PessoaFisicaEmail from "../Componentes/PessoaFisicaEmail"
import PessoaFisicaTelefone from "../Componentes/PessoaFisicaTelefone"
import PessoaFisicaFormacao from "../Componentes/PessoaFisicaFormacao"
import PessoaFisicaExperiencia from "../Componentes/PessoaFisicaExperiencia"
import PessoaFisicaCertificado from "../Componentes/PessoaFisicaCertificado"
import PessoaFisicaPenalidade from "../Componentes/PessoaFisicaPenalidade"
import PessoaFisicaPepSituacao from "../Componentes/PessoaFisicaPepSituacao"

import { IAreaConhecimento, IErroApi, IOcupacaoPrincipal } from "../../../Interfaces/Interfaces";

import { color, resetColor } from "../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../utils/messages";
import {
  IFormacaoPessoaFisica, IEnderecoPessoaFisica,
  IDocumentoPessoaFisica, IEmailPessoaFisica,
  ITelefonePessoaFisica, IExperienciaPessoaFisica,
  ISituacaoPepPessoaFisica, IDadosReceitaCpf,
  ICertificadoPessoaFisica, IPenalidadePessoaFisica
} from "../Componentes/InterfacePessoaFisica";
import PessoaFisicaCargoMandato from "../Componentes/PessoaFisicaCargoMandato";
import { useLocation } from "react-router";
import { isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";
import { converterCargo, IMandatoDirigenteConsulta } from "../../Mandato/Componentes/InterfaceMandato";
import { IOutroCargoConsulta } from "../../OutroCargo/Componentes/InterfaceOutroCargo";
import { IDirigenteExcepcionalConsulta } from "../../DirigenteExcepcional/Componentes/InterfaceDirigenteExcepcional";
import Auditoria from "../../../components/Auditoria";
import { IAuditoria } from "../../../Interfaces/DadosPrevicInterfaces";
import InfoHistorico from "../../../components/InfoHistorico";
import Watermark from "../../../components/WaterMark";
import { IEstado, IPais } from "../../../Interfaces/Localidades";
import { obterAreas, obterGrausInstrucao, obterOcupacoes, obterPepSituacoes } from "../../../services/apiAuxiliar";
import { obterEstados, obterPaises } from "../../../services/apiExternos";
import { maskCpf } from "../../../utils/maskFunctions";
import { DEFAULT_PAGE_SIZE } from "../../parametrosUI";

const { Option } = Select;

const Manter = (props: any) => {
  const { state } = useLocation();

  const [isDirty, setIsDirty] = useState(false);
  const handlerRef = useRef<(e: BeforeUnloadEvent) => void>(null);

  const [estadoPEP] = useState(false);

  const [manter, setManter] = useState(-1); // -1: Estado neutro. Somente para iniciar / 0 : Em consulta / 1 : Inserir / 2 : Detalhar / 3 : Alterar;
  const [dadosPessoaFisica, setDadosPessoaFisica] = useState<IPessoaFisica>();
  const [dadosAuditoria, setDadosAuditoria] = useState<IAuditoria[]>([]);
  const [registroHistorico, setRegistroHistorico] = useState<IAuditoria>();
  const [activeKey, setActiveKey] = useState('item-1');

  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [dadosReceitaCpf, setDadosReceitaCpf] = useState<IDadosReceitaCpf>({});

  const [grausInstrucao, setGrausInstrucao] = useState<any[]>([]);
  const getGrausInstrucao = async () => {
    await obterGrausInstrucao().then((response) => {
      setGrausInstrucao(response);
    });
  }

  const [paises, setPaises] = useState<IPais[]>([]);
  // Retorna todas os países
  const getPaises = async () => {
    await obterPaises().then((response) => {
      setPaises(response?.data);
    });
  };

  const [estados, setEstados] = useState<IEstado[]>([]);

  // Retorna todos os estados do Brasil
  const getEstados = async () => {
    await obterEstados().then((response) => {
      response?.data.sort((a, b) => a.sigla.localeCompare(b.sigla));
      setEstados(response?.data);
    });
  };

  const [areas, setAreas] = useState<IAreaConhecimento[]>([]);
  // Retorna as áreas de conhecimento
  const getAreas = async () => {
    await obterAreas().then((response) => {
      setAreas(response?.data);
    });
  };

  const [ocupacoes, setOcupacoes] = useState<IOcupacaoPrincipal[]>([]);
  const getOcupacoes = async () => {
    await obterOcupacoes().then((response) => {
      setOcupacoes(response?.data);
    });
  };

  const [pepSituacoes, setPepSituacoes] = useState<IPepSituacao[]>([]);
  const getPepSituacoes = async () => {
    await obterPepSituacoes().then((response) => {
      setPepSituacoes(response?.data);
    });
  };

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi]);

  const getPessoaFisicaPorId = async (idPessoaFisica?: number) => {
    try {
      setTipLoading("Atualizando registros históricos");
      setLoading(true);

      let lQuery = `pessoasFisicas/${idPessoaFisica}/full`;
      const { data } = await apiCand.get(lQuery);
      setDadosPessoaFisicaFull(data);

    } catch (error) {
      // console.log(error);
      errorMessage("Erro ao atualizar os registros históricos");
    } finally {
      setLoading(false);
    }
  };

  const atualizarNomeComDadosDaReceita = async () => {
    const cpf = onlyNumbers(form.getFieldValue("nuCpf"));

    setTipLoading("Buscando informações sobre o CPF ...");
    setLoading(true);
    await apiCand.get(`/pessoasFisicas/${cpf}/consulta`).then((response) => {
      setLoading(false);
      if (response?.data) {
        form.setFieldsValue({
          nmPessoaFisica: response?.data?.nome,
        });
      } else {
        errorMessage("Erro ao consultar a base da receita.");
      }
    })
    .catch(err => {
        setLoading(false);
        errorMessage("Erro ao consultar a base da receita.");
      });
  };

  function setDadosPessoaFisicaFull(pf: IPessoaFisica) {
    // console.log("aqui pf");
    // console.log(pf);
    form.setFieldsValue({
      // "idPessoaFisica": state.data.idPessoaFisica,
      "idPessoaFisica": pf.idPessoaFisica,
      // "nuCpf": state.data.nuCpf,
      "nuCpf": maskCpf(pf.nuCpf),
      // "nmPessoaFisica": state.data.nmPessoaFisica,
      "nmPessoaFisica": pf.nmPessoaFisica,
      // "pessoaExpostaPoliticamente": state.data.pessoaExpostaPoliticamente
      "pessoaExpostaPoliticamente": pf.pessoaExpostaPoliticamente,

      "grauInstrucao": grausInstrucao.find(gi => gi.valor === pf.csGrauInstrucao)?.descricao,
      "csGrauInstrucao": pf.csGrauInstrucao,
    });


    setDadosPessoaFisica(pf); // RECUPERA OS DADOS DIRETO DA BASE. ESTA ARRAY MANTÉM INTACTO OS DADOS RECEBIDOS DA BASE, QUE PODERÃO SER UTILIZADOS PARA RECUPERAR INFORMAÇÕES EM CASO DE CANCELAMENTO DE EDIÇÃO.
    // No caso de registro histórico, os demais valores de statusReg também aparecem. Por isso, filtra-se somente statusReg === 1
    setDocumentos(pf.pessoaFisicaDocumentos.filter(e => e.statusReg === 1));
    setEmails(pf.pessoaFisicaEmails.filter(e => e.statusReg === 1));
    setTelefones(pf.pessoaFisicaTelefones.filter(e => e.statusReg === 1));
    setEnderecos(pf.pessoaFisicaEnderecos.filter(e => e.statusReg === 1));
    setFormacoes(pf.pessoaFisicaFormacoes.filter(e => e.statusReg === 1));
    setExperiencias(pf.pessoaFisicaExperienciasProfissionais.filter(e => e.statusReg === 1));
    setCertificados(pf.pessoaFisicaCertificados.filter(e => e.statusReg === 1));
    setPenalidades(pf.pessoaFisicaPenalidades.filter(e => e.statusReg === 1));
    setPessoaFisicaPepSituacoes(pf.pessoaFisicaPepSituacoes.filter(e => e.statusReg === 1));
    if (pf.pessoaFisicaMandatoDirigentes) setMandatosDirigentes(pf.pessoaFisicaMandatoDirigentes);
    if (pf.pessoaFisicaOutrosCargos) setOutroCargos(pf.pessoaFisicaOutrosCargos);
    if (pf.pessoaFisicaDirigentesExcepcionais) setDirigentesExcepcionais(pf.pessoaFisicaDirigentesExcepcionais);

    if (pf.auditoria) setDadosAuditoria(pf.auditoria);

  }

  useEffect(() => {
    const funcao = async() => {
      await getGrausInstrucao();

      const storedHistorico = sessionStorage.getItem("registroHistorico");
      if (storedHistorico) {
        sessionStorage.removeItem("registroHistorico"); // optional: avoids reuse on refresh
        // console.log("historico");
        let json = JSON.parse(storedHistorico);
        // console.log(json.corpoPre);
        setManter(9);
        setDadosPessoaFisicaFull(JSON.parse(json.corpoPre));
        setRegistroHistorico(json);
        mostrarInfo("Registro Histórico", "Você está agora em uma nova janela e vendo um registro histórico. Edições não estão disponíveis");
        setActiveKey('item-1');
        window.scrollTo(0, 0)
      } else if (isStateValid(state)) {
        setManter(state.manter);
        setDadosPessoaFisicaFull(state.data);
      }

      // PREVINE SAIDA DA PÁGINA COM DADOS EM EDIÇÃO
      handlerRef.current = (e: BeforeUnloadEvent) => {
        e.preventDefault();
        e.returnValue = ''; // Still required in most browsers
      };
    }

    funcao();
    
  }, []);

  useEffect(() => {
    if (manter === 1 || manter === 3) { // INSERIR OU ALTERAR
      if (paises.length === 0) {
        getPaises();
        getEstados();
        getAreas();
        getOcupacoes();
        getPepSituacoes();
      }
    }

    if (manter === 0) { // EM CONSULTA
      setDocumentos([]);
    }

    if (manter === 2 && dadosPessoaFisica) { // SE OS DADOS DE PESSOA FÍSICA JÁ ESTIVEREM PREENCHIDO EXIBIR DETALHES - ESTA AÇÃO DECORRE NORMALMENTE QUANDO SE CANCELA A EDIÇÃO
      setDadosPessoaFisicaFull(dadosPessoaFisica);
    }

    if (manter === 3) {
      setActiveKey('item-1');
      setIsDirty(true);
    } else setIsDirty(false);

  }, [manter]);

  useEffect(() => {
    // Verifica se existe registro histórico incompleto. Se sim, consulta o registro novamente para atualizar os dados históricos.
    // Verifica o primeiro e o último registro. Em teoria
    if (!registroHistorico && dadosAuditoria && dadosAuditoria.length > 0) {
      let size = dadosAuditoria.length;
      if (size > 0 && (
        (dadosAuditoria[0].dtPos === undefined || dadosAuditoria[0].dtPos === "")
        || (dadosAuditoria[0].eventos === undefined || dadosAuditoria[0].eventos.length === 0)
      )){
        getPessoaFisicaPorId(dadosPessoaFisica?.idPessoaFisica);
      }
    }
  }, [dadosAuditoria]);

  useEffect(() => {
    if (registroHistorico && manter !== 9) { // AUDITORIA/HISTÓRICO
      // Save data in sessionStorage
      sessionStorage.setItem("registroHistorico", JSON.stringify(registroHistorico));
      // Open new tab
      window.open("/pessoa-fisica/manter", "_blank");
      setActiveKey('item-1');
    }
  }, [registroHistorico]);

  const [form] = Form.useForm();
  const [documentos, setDocumentos] = useState<IDocumentoPessoaFisica[]>([]);
  const [enderecos, setEnderecos] = useState<IEnderecoPessoaFisica[]>([]);
  const [emails, setEmails] = useState<IEmailPessoaFisica[]>([]);
  const [telefones, setTelefones] = useState<ITelefonePessoaFisica[]>([]);
  const [formacoes, setFormacoes] = useState<IFormacaoPessoaFisica[]>([]);
  const [experiencias, setExperiencias] = useState<IExperienciaPessoaFisica[]>([]);
  const [certificados, setCertificados] = useState<ICertificadoPessoaFisica[]>([]);
  const [penalidades, setPenalidades] = useState<IPenalidadePessoaFisica[]>([]);
  const [pessoaFisicaPepSituacoes, setPessoaFisicaPepSituacoes] = useState<ISituacaoPepPessoaFisica[]>([]);
  const [mandatosDirigentes, setMandatosDirigentes] = useState<IMandatoDirigenteConsulta[]>([]);
  const [outrosCargos, setOutroCargos] = useState<IOutroCargoConsulta[]>([]);
  const [dirigentesExcepcionais, setDirigentesExcepcionais] = useState<IDirigenteExcepcionalConsulta[]>([]);

  // Objeto para utilização de passagens de dados entre as telas
  const [estadoPag] = useState({
    fluxoPagina: 9,
    query: "",
    valores: {
      linhaPorPagina: DEFAULT_PAGE_SIZE,
      cnpj: "",
      numeroProcesso: "",
      registroFiscal: "",
      pagina: 1,
      razaoSocial: "",
      apenasConsultadosReceita: false,
    },
  });

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");


  function verificaItensObrigatorios() {
    if ((documentos && documentos.length > 0) && verificaEndereco()) {
      return true;
    } else {
      return false;
    }
  }

  function isPPE() {
    if (pessoaFisicaPepSituacoes && pessoaFisicaPepSituacoes.length > 0 && verificaSitSemDtFim()) {
      form.setFieldsValue({
        pessoaExpostaPoliticamente: true,
      });
      return true;
    } else {
      form.setFieldsValue({
        pessoaExpostaPoliticamente: false,
      });
      return false;
    }
  }

  function verificaSitSemDtFim() {  // SE EXISTIR PELO MENOS UM REGISTRO COM DT_FIM NULL, RETORNA TRUE
    let existeRegSemDtFim = false;
    if (pessoaFisicaPepSituacoes && pessoaFisicaPepSituacoes.length > 0) {
      pessoaFisicaPepSituacoes.forEach((e: ISituacaoPepPessoaFisica) => {
        if (!e.dtFim || e.dtFim === null || e.dtFim === "") existeRegSemDtFim = true;
      });
    }
    return existeRegSemDtFim;
  }

  function verificaEndereco() {  // O BOTÃO SALVAR SOMENTE SERÁ HABILITADO SE EXISTIR PELO MENOS UM ENDEREÇO PESSOAL
    let endOk = false;
    if (enderecos && enderecos.length > 0) {
      enderecos.forEach((e: IEnderecoPessoaFisica) => {
        if (e.csTpEndereco === 1) endOk = true;

      });
    }
    return endOk;
  }


  const validaSendForm = async () => {
    if (documentos && documentos.length > 0 && verificaEndereco()) {
      sendForm();
    } else {
      mostrarInfo("Preenchimento incompleto", "Verifique se existe pelo menos um documento e um endereço do tipo pessoal cadastrados.");
    }
  }

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const cadastro = form.getFieldsValue();
    //    console.log(cadastro);
    const json: IPessoaFisica = {
      //      idPessoaFisica: cadastro?.idPessoaFisica,
      idPessoaFisica: form?.getFieldValue("idPessoaFisica"),
      nuCpf: !cadastro.nuCpf || cadastro.nuCpf === "" ? "" : (onlyNumbers(cadastro?.nuCpf)||""),
      nmPessoaFisica: cadastro?.nmPessoaFisica,
      csGrauInstrucao: form?.getFieldValue("csGrauInstrucao"),
      pessoaExpostaPoliticamente: form?.getFieldValue("pessoaExpostaPoliticamente"),
      statusReg: 1,
      pessoaFisicaDocumentos: documentos.map((e: IDocumentoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaEmails: emails.map((e: IEmailPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaTelefones: telefones.map((e: ITelefonePessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaEnderecos: enderecos.map((e: IEnderecoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaFormacoes: formacoes.map((e: IFormacaoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaExperienciasProfissionais: experiencias.map((e: IExperienciaPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaCertificados: certificados.map((e: ICertificadoPessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaPenalidades: penalidades.map((e: IPenalidadePessoaFisica) => {
        return {
          ...e
        };
      }),
      pessoaFisicaPepSituacoes: pessoaFisicaPepSituacoes.map((e: ISituacaoPepPessoaFisica) => {
        return {
          ...e
        };
      }),
    };

    // console.log("json subindo")
    // console.log(json);

    await apiCand.put(`/pessoasFisicas/${form?.getFieldValue("idPessoaFisica")}`, json).then((response) => {
      setLoading(false);
      //      resetForm();

      getPessoaFisicaPorId(response?.data.idPessoaFisica); // Necessário para atualizar os históricos

      setManter(2);  // MUDA DO ESTADO FO FORM PARA DETALHE.
      successMessage(
        `Pessoa Física ${cadastro?.nmPessoaFisica.toUpperCase()} atualizada com Sucesso.`
      );
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    setDocumentos([]);
    setEmails([]);
    setTelefones([]);
    setEnderecos([]);
    setFormacoes([]);
    setExperiencias([]);
    setCertificados([]);
    setPenalidades([]);
    setPessoaFisicaPepSituacoes([]);
    setMandatosDirigentes([]);
    setOutroCargos([]);
    setDirigentesExcepcionais([]);
    form.setFieldsValue({
      "idPessoaFisica": undefined,
      "nmPessoaFisica": "",
      "nuCpf": "",
      "pessoaExpostaPoliticamente": undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  // Add/remove event listener based on `isDirty`
  useEffect(() => {
    const handler = handlerRef.current!;
    if (isDirty) {
      window.addEventListener('beforeunload', handler);
    } else {
      window.removeEventListener('beforeunload', handler);
    }

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [isDirty]);

  const handlerGrausInstrucao = async (value: any) => {
    form.setFieldsValue({
      grauInstrucao: value.children,
      csGrauInstrucao: value.key,
    });
  };

  return (
    <>
      {/* <Prompt
        when={manter === 3}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}
      <Watermark display={manter === 9 ? "inline" : "none"} />

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className='site-page-header'
          title={manter === 3 ? "Alterar Cadastro de Pessoa Física" : (manter === 2 ? "Detalhar Cadastro de Pessoa Física" : "Consultar Pessoa Física")}
          style={{
            color: colors.white,
            marginTop: "-18px",
            background: colors.blue,
            padding: 5,
            paddingLeft: 24,
            fontSize: "12px",
          }}
        />

        <Card title='Dados Pessoais' variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            onFinish={validaSendForm}

            scrollToFirstError
          >

            <div style={{ display: manter <= 1 ? "none" : "inline" }}>
              <Card title='Dados Pessoais' variant="borderless" style={{ width: "100%" }}>
                <Row>
                  <Col xs={24} md={12} xl={6}>
                    <Form.Item label='CPF'
                      name='nuCpf'
                    >
                      <Input
                        value={form.getFieldValue("nuCpf")}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} xl={14}>
                    <Form.Item label='Nome'
                      name='nmPessoaFisica'>
                      <Input
                        value={form.getFieldValue("nmPessoaFisica")}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} xl={4}>
                    <br/>
                    <Button
                      style={{ display: (manter === 3) ? "inline" : "none" }}
                      shape='round'
                      onClick={() => {
                        atualizarNomeComDadosDaReceita();
                      }}
                    >
                      Atualizar nome
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} xl={10}>
                    <Form.Item label="Grau de instrução"
                      labelCol={{ span: 80 }}
                      name="grauInstrucao"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "O grau de instrução é obrigatório",
                        },
                      ]}
                    >
                      <Select
                        disabled={manter !== 3}
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Selecionar...'
                        onChange={(_, index) => {
                          handlerGrausInstrucao(index);
                        }}
                      >
                        {grausInstrucao?.map((e: any) => (
                          <Option key={e.valor} value={e.valor}>
                            {e.descricao}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              <Tabs activeKey={activeKey} onChange={setActiveKey}>
                <Tabs.TabPane tab="Documentos" key="item-1">
                  <PessoaFisicaDocumento
                    form={form}
                    paises={paises}
                    estados={estados}
                    documentos={documentos}
                    setDocumentos={setDocumentos}
                    manter={manter}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="E-mails" key="item-2">
                  <PessoaFisicaEmail
                    form={form}
                    emails={emails}
                    setEmails={setEmails}
                    color={color}
                    manter={manter}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Telefones" key="item-3">
                  <PessoaFisicaTelefone
                    form={form}
                    telefones={telefones}
                    setTelefones={setTelefones}
                    manter={manter}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Endereços" key="item-4">
                  <PessoaFisicaEndereco
                    paises={paises}
                    estados={estados}
                    enderecos={enderecos}
                    setEnderecos={setEnderecos}
                    form={form}
                    manter={manter}
                    dadosReceitaCpf={{}}
                    setDadosReceitaCpf={setDadosReceitaCpf}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Formação" key="item-5">
                  <PessoaFisicaFormacao
                    formacoes={formacoes}
                    setFormacoes={setFormacoes}
                    areas={areas}
                    form={form}
                    manter={manter}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Experiência Profissional" key="item-6">
                  <PessoaFisicaExperiencia
                    experiencias={experiencias}
                    setExperiencias={setExperiencias}
                    areas={areas}
                    ocupacoes={ocupacoes}
                    form={form}
                    manter={manter}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Certificado" key="item-7">
                  <>
                    <PessoaFisicaCertificado
                      certificados={certificados}
                      setCertificados={setCertificados}
                      form={form}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Penalidade" key="item-8">
                  <>
                    <PessoaFisicaPenalidade
                      penalidades={penalidades}
                      setPenalidades={setPenalidades}
                      form={form}
                      cargos={converterCargo(mandatosDirigentes, outrosCargos, dirigentesExcepcionais)}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Pessoa Exposta Politicamente" key="item-9">
                  <Row>
                    <Col xs={12} xl={12}>
                      <Form.Item
                        name="pessoaExpostaPoliticamente"
                        colon={false}
                      >
                        {/* <Checkbox defaultChecked={estadoPEP} checked={estadoPEP} onChange={handlerPPE} disabled={(pessoaFisicaPepSituacoes.length > 0) || (manter === 1 || manter === 3 ? false : true)}>Pessoa Exposta Politicamente</Checkbox> */}
                        {/* O checkbox será automaticamente marcado ou desmarcado de acordo com as situações de PEP. */}
                        {/* <Checkbox defaultChecked={estadoPEP} checked={estadoPEP} disabled={true}>Pessoa Exposta Politicamente</Checkbox> */}
                        <Checkbox defaultChecked={estadoPEP} checked={isPPE()} disabled={true}>Pessoa Exposta Politicamente</Checkbox>


                      </Form.Item>
                    </Col>
                  </Row>

                  <PessoaFisicaPepSituacao
                    pessoaFisicaPepSituacoes={pessoaFisicaPepSituacoes}
                    setPessoaFisicaPepSituacoes={setPessoaFisicaPepSituacoes}
                    pepSituacoes={pepSituacoes}
                    form={form}
                    manter={manter}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Cargos/Mandatos" key="item-10">
                  <>
                    <PessoaFisicaCargoMandato
                      form={form}
                      mandatosDirigentes={mandatosDirigentes}
                      outrosCargos={outrosCargos}
                      dirigentesExcepcionais={dirigentesExcepcionais}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>

                <Tabs.TabPane disabled={manter !== 2} tab="Histórico" key="item-99" >
                  <>
                    <Auditoria
                      dadosAuditoria={dadosAuditoria}
                      setRegistroHistorico={setRegistroHistorico}
                    />
                  </>
                </Tabs.TabPane>

              </Tabs>
            </div>

            <div style={{ display: manter === 9 ? 'inline' : 'none' }}>
              <InfoHistorico form={form} registroHistorico={registroHistorico} />
            </div>


            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              estadoPag={estadoPag}
              resetColor={resetColor}
              manter={manter}
              verificaItensObrigatorios={verificaItensObrigatorios}
              setManter={setManter}
              setLoading={setLoading}
            />
          </Form>
        </Card>
      </Spin>
    </>
  );
};

export default Manter;